// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-111f3e58]{display:flex;flex-direction:column;align-items:center}.card[data-v-111f3e58]{padding:2rem;background-color:var(--color-divider);color:var(--color-text)}.schedule-title[data-v-111f3e58]{font-size:.7rem;opacity:.8}", ""]);
// Exports
module.exports = exports;
